import React from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionBackgroundIcon } from '@fronton/icons-react';
import { BaseDesignRegistrationPanelProps, DesignRegistrationPanel } from 'common/components';
import { CEILINGS_ELEMENT_BLOCK } from '../../ceilings-constants';

export const CeilingsDesignPanel: React.FC<BaseDesignRegistrationPanelProps> = ({
  isConsultationFormVisible,
  onConsultationSignupBtnClick,
}) => {
  const { t } = useTranslation();

  return (
    <DesignRegistrationPanel
      isConsultationFormVisible={isConsultationFormVisible}
      structure={{
        panel: {
          content: {
            leftIcon: SelectionBackgroundIcon,
            iconColor: 'text-invert',
            iconType: 'duotone',
            text: t('design-panel.text'),
          },
          actionBlock: [{
            elementBlock: CEILINGS_ELEMENT_BLOCK,
            label: t('design-panel.button'),
            variant: 'accent',
            onClick: onConsultationSignupBtnClick,
          }],
        },
        mobilePanel: {
          mobileButton: {
            elementBlock: CEILINGS_ELEMENT_BLOCK,
            label: t('design-panel.button'),
            onClick: onConsultationSignupBtnClick,
          },
          content: {
            icon: SelectionBackgroundIcon,
            iconColor: 'text-invert',
            iconType: 'duotone',
            text: t('design-panel.text') || '',
          },
          actionBlock: [],
        },
      }}
    />
  );
}